import React from 'react';
import { IsObjectEmpty, IsStringEmpty } from '../../../utilities/CommonMethods';
import classes from './CopyLiveSessionDetailForm.module.css';
import Button from '../../UI/Button/Button';
import CloseIcon from "../../../assets/icons/icon-close-black.png";
import FlexModal from '../../UI/FlexModal/FlexModal';
import NewInputDropDown from '../../UI/NewInputDropdown/NewInputDropDown';
import ResourceAPIController from '../../../webServices/ResourceAPIController';
import ShowMiniLoader from "../../../hoc/ShowMiniLoader/ShowMiniLoader";
import { parseDate } from '../../../utilities/DateTimeUtils';

class CopyLiveSessionDetailForm extends React.Component {

    state = {
        allProgramsBatchCode: [],
        selectedPos: 0,
        modulesList: [{ id: -1, name: "-" }],
        topicList: [{ id: -1, name: "-" }],
        selectedModule: "",
        selectedModulePos: 0,
        isModulesFetched: false,
        isTopicFetched: false,
        errorBatch: false,
        errorModule: false,
        errorTopic: false,
        disableButton: true,
        isLoadingButton: false,
    }
    getModuleTemplateDetails = (batchCode, moduleName) => {
        ResourceAPIController.getModuleTemplateDetails(batchCode, moduleName)
            .then(response => {
                let responseObj = response.result.programsList;

                let parsedProgramData = responseObj.map((data, idx) => {
                    return { id: idx + 1, name: data.name }
                })
                parsedProgramData.unshift({ id: -1, name: "-" });
                this.setState({ allProgramsBatchCode: parsedProgramData });
            })
            .catch(err => {
                console.log('getModuleTemplateDetails error => ', err)

                if (err.error.status === 400) {
                    this.props.showFailureDialog(err.error.message, 'OKAY');
                } else if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                } else {
                    this.props.showFailureDialog(err.error.message, 'OKAY');
                }
            });
    }
    getModulesList = () => {
        this.setState({ isModulesFetched: false, disableButton: true, modulesList: [{ id: -1, name: "Loading..." }], selectedModulePos: 0 });

        ResourceAPIController.getAllModulesListForProgram(this.state.batchCode)
            .then(response => {
                let responseObj = response.result;

                let parsedModuleData = responseObj.modulesList.map((data, index) => {
                    return {
                        id: index + 1,
                        name: data.title
                    }
                })
                parsedModuleData.unshift({ id: -1, name: "-" });
                this.setState({ modulesList: parsedModuleData, isModulesFetched: true, selectedModulePos: 0 })

            })
            .catch(err => {
                console.log('getAllModulesListForProgram error => ', err)
                this.setState({ isModulesFetched: true });
            });

    }
    getTopicList = () => {
        this.setState({ isTopicFetched: false, disableButton: true, topicList: [{ id: -1, name: "Loading..." }], selectedTopicPos: 0 });
        ResourceAPIController.getCurriculumTopicsListData(this.state.batchCode, this.state.selectedModule)
            .then(response => {
                let responseObj = response.result.topicsList;
                responseObj = responseObj.filter(data => data.type === "topic")
                let parsedModuleData = responseObj.map((data, index) => {
                    return {
                        id: data.topicId,
                        name: data.label + " ," + parseDate(data.date.split(",").slice(0, 1).join(""), true, true),
                    }


                })
                parsedModuleData.unshift({ id: -1, name: "-" });
                this.setState({ topicList: parsedModuleData, isTopicFetched: true, selectedTopicPos: 0 })

            })
            .catch(err => {
                console.log('getAllTopicListForProgram error => ', err)
                this.setState({ isTopicFetched: true });
            });
    }
    getSelectedBatchCode = (pos, idx, id) => {
        (pos === 0) ? this.setState({ errorBatch: true, disableButton: true }) : this.setState({ errorBatch: false, disableButton: false });
        this.setState({ batchCode: this.state.allProgramsBatchCode[pos].name, selectedPos: pos })
    }

    getSelectedModule = (pos, idx, id) => {
        (pos === 0) ? this.setState({ errorModule: true, disableButton: true }) : this.setState({ errorModule: false, disableButton: false });
        this.setState({ selectedModule: this.state.modulesList[pos].name, selectedModulePos: pos })
    }
    getSelectedTopic = (pos, idx, id) => {
        (pos === 0) ? this.setState({ errorTopic: true, disableButton: true }) : this.setState({ errorTopic: false, disableButton: false });
        this.setState({ selectedTopic: this.state.topicList[pos].name, selectedTopicPos: pos })
    }
    onFormButtonClicked = () => {
        this.setState({ isLoadingButton: true, });
        let response = {
            "topic_id": this.state.topicList[this.state.selectedTopicPos].id
        };
        var liveSessionId = !IsObjectEmpty(this.props.data.liveSessionList[0]) && !IsStringEmpty(this.props.data.liveSessionList[0].liveSessionId) ? this.props.data.liveSessionList[0].liveSessionId : null;
        ResourceAPIController.copyLiveSessionDetail(response, liveSessionId)
            .then(response => {
                this.props.closePopup();
                this.setState({
                    allProgramsBatchCode: [],
                    selectedPos: 0,
                    modulesList: [{ id: -1, name: "-" }],
                    topicList: [{ id: -1, name: "-" }],
                    selectedModule: "",
                    selectedModulePos: 0,
                    isModulesFetched: false,
                    isTopicFetched: false,
                    errorBatch: false,
                    errorModule: false,
                    errorTopic: false,
                    disableButton: true,
                    isLoadingButton: false,
                })
                this.props.onSuccessDialogShow(response.result, 'DONE');
                this.getModuleTemplateDetails("IVYJFST0621", "Data Structures and Algo");
            })
            .catch(err => {
                this.props.closePopup();
                console.log("Copy Live Session Detail Form Error Message", err.error.message);
                this.setState({ errorMessage: err.error.message, isLoadingButton: false });
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                } else if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                } else {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
            });
    }


    componentDidMount() {
        this.getModuleTemplateDetails("IVYJFST0621", "Data Structures and Algo");
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.batchCode !== this.state.batchCode) {
            this.getModulesList();
        }
        if (prevState.selectedModule !== this.state.selectedModule) {
            this.getTopicList();
        }
    }

    render() {
        return (
            <FlexModal visible={true} forSessionPlanForm={true} fullScreenMobile={true} backdropClicked={() => this.props.closePopup('')}>
                <div className={classes.Form}>
                    <h5 className={classes.Heading}>Copy Live Session Details</h5>

                    <img src={CloseIcon} alt={'Hide form'} className={classes.CloseIcon}
                        onClick={this.props.closePopup} />
                    <div className={classes.Full}>
                        <NewInputDropDown
                            padding={true}
                            forFormPage={true}
                            dropdownItemsList={this.state.allProgramsBatchCode}
                            activeItemPos={this.state.selectedPos}
                            dropdownItemClicked={this.getSelectedBatchCode}
                            title={"Batch Code"}
                            id="instructor"
                            reduceTopMargin={true}
                            width={"40%"}
                        />
                        {
                            this.state.errorBatch ? (<p className={classes.ErrorText}>Select a valid batch</p>) : null
                        }
                    </div>
                    <div>
                        <div className={classes.Full}>
                            <NewInputDropDown
                                padding={true}
                                forFormPage={true}
                                dropdownItemsList={this.state.modulesList}
                                activeItemPos={this.state.selectedModulePos}
                                dropdownItemClicked={this.getSelectedModule}
                                title={"Select Module"}
                                id="instructor"
                                reduceTopMargin={true}
                                width={"40%"}
                                isModulesFetched={this.state.isModulesFetched}
                            />
                            {
                                this.state.errorModule ? (<p className={classes.ErrorText}>Select a valid module</p>) : null
                            }
                        </div>
                        <div className={classes.Full}>
                            <NewInputDropDown
                                padding={true}
                                forFormPage={true}
                                dropdownItemsList={this.state.topicList}
                                activeItemPos={this.state.selectedTopicPos}
                                dropdownItemClicked={this.getSelectedTopic}
                                title={"Select Topic"}
                                id="instructor"
                                reduceTopMargin={true}
                                width={"40%"}
                                isTopicFetched={this.state.isTopicFetched}
                            />
                            {
                                this.state.errorTopic ? (<p className={classes.ErrorText}>Select a valid topic</p>) : null
                            }
                        </div>
                    </div>
                    <div className={classes.SubmitButton}>
                        {!this.state.isLoadingButton ? (
                            <Button
                                styleclass="NonMobileOnly"
                                label={"COPY DETAILS"}
                                fontSize="0.8em"
                                padding="1em 3.5em"
                                margin="0 0 1.5em 0"
                                disabled={this.state.disableButton ? true : false}
                                clicked={this.onFormButtonClicked}
                            />
                        ) : (
                            <div className={classes.LoaderBar}>
                                <ShowMiniLoader isLoading={true} transparentBg={true} />
                            </div>
                        )}
                    </div>
                </div>
            </FlexModal>
        );
    }

}

export default CopyLiveSessionDetailForm;